import FileUploadZone from './FileUploadZone';

export default FileUploadZone;
